import React, { useEffect, useState } from 'react'
import { leaV3API, TimeoutRow } from '../api/leaV3.api'

export const TimeoutsView: React.FC = () => {
  const [rows, setRows] = useState<TimeoutRow[]>([])
  const [category, setCategory] = useState('')
  const [expiredOnly, setExpiredOnly] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    leaV3API
      .getTimeouts({
        category: category || undefined,
        expired: expiredOnly || undefined,
        limit: 500
      })
      .then((r) => setRows(r.data))
      .finally(() => setLoading(false))
  }, [category, expiredOnly])

  return (
    <div className="space-y-4">
      <div className="flex gap-3 items-center">
        <label className="text-sm text-gray-600">Catégorie</label>
        <input
          className="border rounded px-2 py-1 text-sm"
          placeholder="ex: rappel_paiement"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <label className="text-sm text-gray-600 flex items-center gap-1">
          <input type="checkbox" checked={expiredOnly} onChange={(e) => setExpiredOnly(e.target.checked)} />
          Expirés seulement
        </label>
        <span className="text-xs text-gray-500 ml-auto">{rows.length} timeouts</span>
      </div>

      {loading ? (
        <div className="p-4 text-gray-500">Chargement…</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 text-xs">
            <thead className="bg-gray-50 text-gray-700">
              <tr>
                <th className="px-2 py-2 text-left">Affaire</th>
                <th className="px-2 py-2 text-left">Statut</th>
                <th className="px-2 py-2 text-left">Catégorie</th>
                <th className="px-2 py-2 text-left">Ladder slot</th>
                <th className="px-2 py-2 text-left">Expires at</th>
                <th className="px-2 py-2 text-left">Set by</th>
                <th className="px-2 py-2 text-left">Reason</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.affaire_id}
                  className={`border-t border-gray-100 ${r.is_expired ? 'bg-[#fff1ef]' : ''}`}
                >
                  <td className="px-2 py-1 font-mono">#{r.affaire_id}</td>
                  <td className="px-2 py-1">{r.status}</td>
                  <td className="px-2 py-1">{r.category}</td>
                  <td className="px-2 py-1 font-mono text-gray-600">{r.ladder_slot || '—'}</td>
                  <td className={`px-2 py-1 ${r.is_expired ? 'text-[#ef5343] font-semibold' : ''}`}>
                    {new Date(r.expires_at).toLocaleString('fr-BE')}
                  </td>
                  <td className="px-2 py-1">{r.set_by}</td>
                  <td className="px-2 py-1 text-gray-500 max-w-xs truncate" title={r.reason || ''}>
                    {r.reason || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
